import {
  IBillingByPeriodApiResponse,
  IBillingByRatioApiResponse,
  IBusinessLineApiResponse,
  IKmByClientApiResponse,
  IKmByPeriodApiResponse,
  ITotalKmResponseApi,
  IUnpaidSalesApiResponse,
} from '../interfaces/query-engine.interface';
import { Function, QueryConfig } from '../interfaces/query.interface';

export const unpaidSalesMocks: IUnpaidSalesApiResponse[] = [
  {
    sin_cobrar: 56788292,
    cobrado: 73983,
  },
];

export const billingByPeriodMocks: IBillingByPeriodApiResponse[] = [
  {
    facturado: '126568',
    mes: '01-2025',
  },
  {
    facturado: '125268',
    mes: '02-2025',
  },
  {
    facturado: '226468',
    mes: '03-2025',
  },
  {
    facturado: '925568',
    mes: '04-2025',
  },
  {
    facturado: '276568',
    mes: '05-2025',
  },
];

export const billingByRatioMocks: IBillingByRatioApiResponse[] = [
  {
    facturado: '596829',
    id_tipo_cliente: '1',
    tipo_cliente: 'Cliente pagador',
    id_cliente_pagador: 1,
  },
  {
    facturado: '27837829',
    id_tipo_cliente: '2',
    tipo_cliente: 'Cliente pagador',
    id_cliente_pagador: 1,
  },
  {
    facturado: '652829',
    id_tipo_cliente: '3',
    tipo_cliente: 'Cliente pagador',
    id_cliente_pagador: 1,
  },
  {
    facturado: '27107829',
    id_tipo_cliente: '4',
    tipo_cliente: 'Cliente pagador',
    id_cliente_pagador: 1,
  },
  {
    facturado: '12837829',
    id_tipo_cliente: '5',
    tipo_cliente: 'Cliente pagador',
    id_cliente_pagador: 1,
  },
  {
    facturado: '536829',
    id_tipo_cliente: '6',
    tipo_cliente: 'Cliente pagador',
    id_cliente_pagador: 1,
  },
  {
    facturado: '2837829',
    id_tipo_cliente: '7',
    tipo_cliente: 'Cliente pagador',
    id_cliente_pagador: 1,
  },
  {
    facturado: '6212829',
    id_tipo_cliente: '8',
    tipo_cliente: 'Cliente pagador',
    id_cliente_pagador: 1,
  },
  {
    facturado: '1710789',
    id_tipo_cliente: '9',
    tipo_cliente: 'Cliente pagador',
    id_cliente_pagador: 1,
  },
  {
    facturado: '127829',
    id_tipo_cliente: '10',
    tipo_cliente: 'Cliente pagador',
    id_cliente_pagador: 1,
  },
  {
    facturado: '5968290',
    id_tipo_cliente: '11',
    tipo_cliente: 'Cliente pagador',
    id_cliente_pagador: 1,
  },
  {
    facturado: '17837829',
    id_tipo_cliente: '12',
    tipo_cliente: 'Cliente pagador',
    id_cliente_pagador: 1,
  },
  {
    facturado: '1652829',
    id_tipo_cliente: '13',
    tipo_cliente: 'Cliente pagador',
    id_cliente_pagador: 1,
  },
  {
    facturado: '2710729',
    id_tipo_cliente: '14',
    tipo_cliente: 'Cliente pagador',
    id_cliente_pagador: 1,
  },
  {
    facturado: '1283429',
    id_tipo_cliente: '15',
    tipo_cliente: 'Cliente pagador',
    id_cliente_pagador: 1,
  },
];

export const kmByPeriodMocks: IKmByPeriodApiResponse[] = [
  {
    km: '73892',
    mes: '01-2025',
  },
  {
    km: '26892',
    mes: '02-2025',
  },
  {
    km: '79692',
    mes: '03-2025',
  },
  {
    km: '46892',
    mes: '04-2025',
  },
  {
    km: '23892',
    mes: '05-2025',
  },
  {
    km: '12892',
    mes: '06-2025',
  },
];

export const kmByClientMocks: IKmByClientApiResponse[] = [
  {
    km: '12332',
    tipo_cliente: 'Cliente pagador',
    id_tipo_cliente: 1,
  },
  {
    km: '65332',
    tipo_cliente: 'Cliente descarga',
    id_tipo_cliente: 2,
  },
  {
    km: '35332',
    tipo_cliente: 'Cliente de carga',
    id_tipo_cliente: 3,
  },
  {
    km: '89332',
    tipo_cliente: 'Cliente pagador y garda y descarga',
    id_tipo_cliente: 4,
  },
  {
    km: '92332',
    tipo_cliente: 'Cliente pagador',
    id_tipo_cliente: 5,
  },
];

export const businessLinesMocks: IBusinessLineApiResponse[] = [
  {
    facturado: '17829',
    linea_negocio: 'Grupaje',
    id_linea_negocio: 1,
  },
  {
    facturado: '25829',
    linea_negocio: 'Marítimo',
    id_linea_negocio: 2,
  },
  {
    facturado: '34829',
    linea_negocio: 'Logística',
    id_linea_negocio: 3,
  },

  {
    facturado: '4569',
    linea_negocio: 'Alquileres',
    id_linea_negocio: 4,
  },
  {
    facturado: '22829',
    linea_negocio: 'DISTRIBUCIÓN',
    id_linea_negocio: 5,
  },
  {
    facturado: '17829',
    linea_negocio: 'Grupaje',
    id_linea_negocio: 6,
  },
  {
    facturado: '25829',
    linea_negocio: 'Marítimo',
    id_linea_negocio: 7,
  },
  {
    facturado: '34829',
    linea_negocio: 'Logística',
    id_linea_negocio: 8,
  },

  {
    facturado: '4569',
    linea_negocio: 'Alquileres',
    id_linea_negocio: 9,
  },
  {
    facturado: '22829',
    linea_negocio: 'DISTRIBUCIÓN',
    id_linea_negocio: 10,
  },
  {
    facturado: '34829',
    linea_negocio: 'Logística',
    id_linea_negocio: 11,
  },

  {
    facturado: '4569',
    linea_negocio: 'Alquileres',
    id_linea_negocio: 12,
  },
  {
    facturado: '22829',
    linea_negocio: 'DISTRIBUCIÓN',
    id_linea_negocio: 13,
  },
];

export const totalKmMocks: ITotalKmResponseApi[] = [
  {
    km_total: '188221',
    km_vacios: '22781',
    km_facturables: '287272',
  },
];

export const queryConfigMock: QueryConfig = {
  schema: 'tenant_testdata',
  select: [
    {
      type: 3,
      function: Function.GROUPCOUNT,
      field1: {
        table: 'film',
        attribute: 'film_id',
      },
    },
  ],
  version: 0.1,
};

export const logisticsMocks: Record<string, Record<string, number>> = {
  'lf-stock-1-mock': {
    '$lf-stock.total_pallets': 235,
    '$lf-stock.pallets_over_1600': 79,
    '$lf-stock.pallets_under_1600': 154,
  },
  'lf-stock-2-mock': {
    '$lf-stock.total_pallets': 1819,
    '$lf-stock.pallets_over_1600': 647,
    '$lf-stock.pallets_under_1600': 1172,
  },
  'lf-stock-3-mock': {
    '$lf-stock.total_pallets': 1447,
    '$lf-stock.pallets_over_1600': 699,
    '$lf-stock.pallets_under_1600': 748,
  },
  'lf-stock-4-mock': {
    '$lf-stock.total_pallets': 2419,
    '$lf-stock.pallets_over_1600': 785,
    '$lf-stock.pallets_under_1600': 1634,
  },
  'lf-stock-5-mock': {
    '$lf-stock.total_pallets': 0,
    '$lf-stock.pallets_over_1600': 0,
    '$lf-stock.pallets_under_1600': 0,
  },
  'lf-prod-1-mock': {
    '$lf-stock.total_pallets': 508,
    '$lf-stock.pallets_over_1600': 16,
    '$lf-stock.pallets_under_1600': 492,
  },
  'lf-rec-1-mock': {
    '$lf-stock.total_pallets': 33,
    '$lf-stock.pallets_over_1600': 9,
    '$lf-stock.pallets_under_1600': 24,
  },
  'lf-rec-2-mock': {
    '$lf-stock.total_pallets': 129,
    '$lf-stock.pallets_over_1600': 20,
    '$lf-stock.pallets_under_1600': 109,
  },
  'lf-rec-3-mock': {
    '$lf-stock.total_pallets': 15,
    '$lf-stock.pallets_over_1600': 0,
    '$lf-stock.pallets_under_1600': 15,
  },
  'lf-rec-4-mock': {
    '$lf-stock.total_pallets': 415,
    '$lf-stock.pallets_over_1600': 288,
    '$lf-stock.pallets_under_1600': 127,
  },
};
